import './About.css';

const About = () => (
  <div className="about-container">
    <h1 style={{ fontWeight: 700, fontSize: '2.2rem', marginBottom: 16 }}>
      About Rolling Thunder Cycles
    </h1>
    <p style={{ fontSize: '1.15rem', color: '#333', marginBottom: 24 }}>
      <b>Rolling Thunder Cycles, Inc.</b> was founded in 1981. Owners Tom and
      Gerard had worked for various Harley-Davidson dealers for several years,
      and they felt that there was a need for a source of quality parts,
      accessories and service in the area. On April 1st 1981 they opened the
      store that soon became one of the best aftermarket shops around. In the
      Fall of 1999, Rolling Thunder Cycles moved to across the street. The
      newest store featured an improved and updated Service Department, as well
      as a more efficient Parts Department. The motorcycle showroom moved
      onto the World Wide Web as a "Virtual Showroom" where dozens of bikes were
      marketed to prospective buyers around the world. We offered the finest in Parts, Accessories, Service work, Custom
      Paint, Metal Finishes, and apparel for your Harley-Davidson until our retirement in 2025.
    </p>
   
    
    
  </div>
);

export default About;
